import type { SymbolDefinition } from "../types.ts";

export const indicatorLight: SymbolDefinition = {
  id: "ep-indicator-light",
  familyKey: "indicator_light",
  deviceKind: "indicator_light",
  version: "0.1.0",
  label: { sv: "Signallampa", en: "Indicator light" },
  description: { sv: "Panellampa.", en: "Panel indicator light." },
  viewBox: "0 0 24 24",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <circle cx="12" cy="12" r="6"/>
      <line x1="8" y1="8" x2="16" y2="16"/>
      <line x1="16" y1="8" x2="8" y2="16"/>
      <line x1="12" y1="2" x2="12" y2="6"/>
      <line x1="12" y1="18" x2="12" y2="22"/>
    </g>
  `,
  terminals: [
    { id: "in", kind: "control", label: "X1", position: "top", offset: 0.5 },
    { id: "out", kind: "control", label: "X2", position: "bottom", offset: 0.5 },
  ],
  designationPrefix: "H",
  searchKeywords: ["signallampa", "lampa", "indicator"],
};
